import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hint"]

  hide() {
    if (this.hasHintTarget) {
      this.hintTarget.classList.add("hidden")
    }
  }
}
